import React, { useState, useEffect } from "react";
import Grid from "apollo-react/components/Grid";
import { useTranslation } from "react-i18next";
import Typography from "apollo-react/components/Typography";
import DraftCard from "./DraftCard";
import { getDrafts, deleteDraft } from "../../../../utils/draftStorage";
import { toast } from "react-toastify";

const DraftsList = ({ onDraftsChange }) => {
  const { t } = useTranslation();
  const [drafts, setDrafts] = useState([]);
  const [filteredDrafts, setFilteredDrafts] = useState([]);

  const loadDrafts = () => {
    const loadedDrafts = getDrafts();
    setDrafts(loadedDrafts);
    setFilteredDrafts(loadedDrafts);
    if (onDraftsChange) {
      onDraftsChange(loadedDrafts);
    }
  };

  useEffect(() => {
    loadDrafts();
  }, []);

  const handleDelete = (draftId) => {
    const result = deleteDraft(draftId);
    if (result.success) {
      toast.success(t('Draft deleted successfully'), {
        position: "top-center",
        autoClose: 3000,
      });
      loadDrafts();
    } else {
      toast.error(t('Failed to delete draft'), {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  if (drafts.length === 0) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Typography variant="h6" color="textSecondary">
              {t('noDraftsFound')}
            </Typography>
          </div>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {filteredDrafts.map((draft) => (
          <DraftCard
            key={draft.draftId}
            draft={draft}
            onDelete={handleDelete}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default DraftsList;

